import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-role',
    templateUrl: './editor-eligibility-rule-form-has-role.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormHasRoleComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  roleNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.roleNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(roleNames => this.roleNames = roleNames);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
